// Bullet-proof fetch helpers that avoid "body stream already read" errors
// when third-party scripts (analytics, service workers) intercept fetch.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

async function readJsonSafe(res) {
  // Try to read the response as text first (more resilient than .json()
  // when an interceptor has cloned/consumed the stream).
  try {
    const text = await res.text();
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch {
      return { raw: text };
    }
  } catch {
    return null;
  }
}

export async function publicGet(path) {
  const res = await fetch(`${BACKEND_URL}${path}`, { method: 'GET' });
  const data = await readJsonSafe(res);
  if (!res.ok) {
    throw new Error((data && (data.detail || data.message)) || `HTTP ${res.status}`);
  }
  return data;
}

export async function publicPost(path, body) {
  const res = await fetch(`${BACKEND_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const data = await readJsonSafe(res);
  if (!res.ok) {
    throw new Error((data && (data.detail || data.message)) || `HTTP ${res.status}`);
  }
  return data;
}

export async function publicPut(path, body) {
  const res = await fetch(`${BACKEND_URL}${path}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const data = await readJsonSafe(res);
  if (!res.ok) {
    throw new Error((data && (data.detail || data.message)) || `HTTP ${res.status}`);
  }
  return data;
}
